import Swiper, { Autoplay, EffectFade } from 'swiper';

let firstSecSwiperWr = document.querySelectorAll('.first-slider-swiper-wr');

firstSecSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, EffectFade],
      speed: 2000,
      slidesPerView: 1,
      effect: 'fade',
      autoplay: false,
    });

    setTimeout(() => {
      swiper.params.autoplay = {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      };
      swiper.autoplay.start();
    }, 5000);
  }
});
